export default (app) => {
  app.session = app.addeventhandler({}, ["login", "logout"], "session");
  const { session } = app;

  const goto = (path, push) =>
    push ? window.history.pushState({}, "", path) : window.history.replaceState({}, "", path);

  app.on("init", -1, async () => {
    function loginEvent(user) {
      if (typeof user.role === "string") user.role = [user.role];
      if (JSON.stringify(user) !== JSON.stringify(session.user)) {
        try {
          app.storage.setItem({ id: `session`, value: user });
        } catch (e) {}
      }
      session.user = user;
      app.event("login", user);
    }

    session.on("login", ({ sessionid, ...data }) => app.connection.emit({ type: "login", sessionid, data }));

    app.connection.on(["emit", "login"], -10, async ({ type, user, error, redirectURL, sessionid, offline }) => {
      if (type !== "login" || offline) return;

      if (user) {
        if (!error) {
          if (redirectURL) goto(redirectURL, true);
          loginEvent(user);
        }
      } else if (session.user && sessionid === session.user?.sessionid) session.logout();

      return { type, user, error };
    });

    const reload = ({ key, id }) => {
      if ((key || id) !== `session`) return;
      setTimeout(() => window.location.reload(), 0);
    };
    window.addEventListener("storage", reload);
    app.storage.on("removeItem", -1000, reload);
    app.storage.on("setItem", -1000, reload);

    session.on("logout", () => {
      delete session.user;

      app.connection.emit({ type: "logout", noCallback: true });

      app.event("clearCacheAndReload");
      app.event("logout");
    });

    app.connection.on("logout", () => {
      app.event("clearCacheAndReload");
    });

    app.connection.on("connection", 50, async ({ connected }) => {
      if (connected && session.user) await session.login(session.user);
    });

    const { value: userStore } = await app.storage.getItem({ id: `session` });
    if (!session.user && userStore) {
      session.user = userStore;
      if (typeof session.user.role === "string") session.user.role = [session.user.role];
      app.event("login", session.user);
    }
    if (session.user && app.connection.connected) await session.login(session.user);
  });
};
